import React from 'react';
import InputNumber from './InputNumber';

const BuyingPower = ({ buyingPower, setBuyingPower }) => (
  <InputNumber
    label="Min. Buying Power"
    getter={buyingPower}
    setter={setBuyingPower}
  />
);

export default BuyingPower;
